import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  max-width: 600px;
  margin: 20px auto;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 15px;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 100%;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 100%;
`;

const Textarea = styled.textarea`
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 100%;
  height: 100px;
  resize: vertical;
`;

const Button = styled.button`
  padding: 10px 15px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
`;

const Submission = () => {
  const [selectedMilestone, setMilestone] = useState("");
  const [file, setFile] = useState(null);
  const [description, setDescription] = useState("");
  
  const milestones = [
    { title: 'Team Formation', dueDate: '2023-08-20' }, 
    { title: 'Capstone Theme Publishing', dueDate: '2023-08-25' }, 
    { title: 'Idea Selection and Documentation', dueDate: '2023-09-01' },
    {title:'Capstone Portfolio Section I', dueDate: '2023-09-15'},
    {title:'Panel Review Decision', dueDate: '2023-10-01'},
    {title:'Portfolio Section II', dueDate: '2023-10-01'},
    {title:'BMC', dueDate: '2023-10-01'},
    {title:'Portfolio Section III', dueDate: '2023-10-01'},
    // ... Add all other milestones with their respective due dates
  ];

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    console.log("File:", file);
    console.log("Description:", description);
    console.log("Selected Milestone:", selectedMilestone);
    
    setFile(null);
    setDescription("");
    setMilestone("");
  };

  return (
    <Container>
      <h2>Capstone Project Submission</h2>
      <Form onSubmit={handleSubmit}>
        <Label>
          Select Milestone:
          <Select value={selectedMilestone} onChange={(e) => setMilestone(e.target.value)}>
            <option value="">--Please choose a milestone--</option>
            {milestones.map(milestone => (
              <option key={milestone.title} value={milestone.title}>
                {milestone.title} (Due: {milestone.dueDate})
              </option>
            ))}
          </Select>
        </Label>
        
        <Label>
          Upload File:
          <Input type="file" onChange={handleFileChange} />
        </Label>
        
        <Label>
          Description:
          <Textarea value={description} onChange={(e) => setDescription(e.target.value)} />
        </Label>

        <Button type="submit">Submit</Button>
      </Form>
    </Container>
  );
};

export default Submission;
